import { useValidation } from '@/components';

export const useValidationSchema = () => {
  const createValidationSchema = useValidation();

  return createValidationSchema(
    ({
      t,
      isEntity,
      isDateRequired,
      isStringRequired,
      isStringMaxLength,
      isStringMaxLengthOptional,
    }) => ({
      caption: isStringMaxLength(200),
      type: isStringMaxLengthOptional(100),
      preview: isStringMaxLengthOptional(1024),
      markdownData: isStringRequired(),
      company: isEntity('Company'),
      dateValidFrom: isDateRequired(),
      dateValidTo: isDateRequired().test(
        'DateValidToGreaterThanDateValidFrom',
        t('DateValidToGreaterThanDateValidFrom'),
        function (dateValidTo) {
          const dateValidFrom = this.parent.dateValidFrom;
          return !dateValidTo || !dateValidFrom || new Date(dateValidTo) >= new Date(dateValidFrom);
        },
      ),
    }),
  );
};
